import React from "react";
import QuizSuccessIcon from "../../images/svgs/QuizSuccessIcon";
import CustomButton from "../customButtom/CustomButton";
import { useNavigate } from "react-router-dom";
const QuizComplete = () => {
  const navigate = useNavigate();
  const handleComplete = () => {
    navigate("/dashboard/home");
  };
  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-white rounded-xl">
      <div className=" p-4 sm:p-6 flex flex-col gap-3 items-center text-center w-full max-w-lg md:max-w-2xl">
        <QuizSuccessIcon />
        <p className="font-bold text-3xl">Success</p>
        <p className="font-medium text-sm sm:text-base text-gray-500 mt-2.5">
          Your assessment is complete and your results are ready.
        </p>
        <div className="flex gap-2">
          <CustomButton
            label={"View Result"}
            onClick={() => navigate("/dashboard/ai-literacy-results")}
            buttonClass="bg-custom-blue px-5 rounded-md transition-all duration-300 hover:opacity-90  hover:shadow-lg"
          />
          <CustomButton label={"Go to Dashboard"} onClick={handleComplete} />
        </div>
      </div>
    </div>
  );
};

export default QuizComplete;
